import { Typography } from '@material-ui/core';
import React from 'react';
import { useTranslate } from 'react-admin';

import { InfoBox } from './InfoBox';

export const GPSEditorInstructions: React.FC = () => {
  const translate = useTranslate();
  return (
    <InfoBox
      title={translate('osfc.storage_ui.gps_editor.title')}
      style={{ maxWidth: "350px" }}
    >
      <Typography variant="body2" style={{ margin: "0 0 4px 0" }}>
        • <strong>{translate('osfc.storage_ui.gps_editor.drag')}</strong> {translate('osfc.storage_ui.gps_editor.move_gps_points')}
      </Typography>
    </InfoBox>
  );
};
